import { pr, React, theme } from "aaa";

export const CardWithIcon = (props: {
    icon: string | React.ReactNode,
    checked: boolean,
    onClick: any,
    "aria-label"?: string,
    style?: React.CSSProperties,
}) => {
    const iconSize = 44;
    const color = props.checked ? theme.customColors.georgeLightBlue : theme.customColors.georgeLightGrey;
    const cardSize = 50;
    const cardWidth = cardSize * 3;
    const cardHeight = cardSize * 1.8;

    return (
        <pr.HFlexCentered
            style={{
                position: "relative",
                width: cardWidth,
                height: cardHeight,
                marginLeft: "auto",
                marginRight: "auto",
                borderStyle: "solid",
                borderColor: color,
                borderRadius: 6,
                cursor: "pointer",
                boxSizing: "border-box",
                ...props.style,
            }}
            onClick={props.onClick}
            role="button"
            aria-label={props["aria-label"]}
            aria-pressed={props.checked}
        >
            {typeof props.icon === "string" ? (
                <pr.GeorgeIconWrapper
                    color={color}
                    size={iconSize}
                    iconName={props.icon}
                />
            ) : props.icon
            }

            {props.checked &&
                <pr.IconCheck
                    style={{
                        position: "absolute",
                        color,
                        top: 10,
                        right: 10
                    }}
                />}
        </pr.HFlexCentered>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/CardWithIcon.tsx